<script>
  import { Block, GraphicBlock } from '@reuters-graphics/graphics-components';
  import { assets } from '$app/paths';
  import { lerp } from './utils';

  let { note, source, title, description, notes } = $props();

  let currentTime = $state(0);
  let videoDuration = $state(1);
  let startEpoch = 1771977600000;
  let endEpoch = 1772841600000;

  function formatAPStyle(date) {
    const days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    const months = [
      'Jan.',
      'Feb.',
      'March',
      'April',
      'May',
      'June',
      'July',
      'Aug.',
      'Sept.',
      'Oct.',
      'Nov.',
      'Dec.',
    ];

    const day = days[date.getUTCDay()];
    const month = months[date.getUTCMonth()];
    const dateNum = date.getUTCDate();
    // const year = date.getUTCFullYear();

    let hours = date.getUTCHours();
    // const minutes = Math.floor(date.getUTCMinutes() / 5) * 5;
    const period = hours >= 12 ? 'p.m.' : 'a.m.';

    hours = hours % 12;
    if (hours === 0) hours = 12;

    // const minutesStr = minutes.toString().padStart(2, '0');

    return `${day}, ${month} ${dateNum}, ${hours} ${period} GMT`;
  }

  let actualTime = $derived(
    formatAPStyle(
      new Date(lerp(currentTime, 0, videoDuration, startEpoch, endEpoch))
    )
  );
</script>

<GraphicBlock
  width="wide"
  id="tankers-video-block"
  {title}
  {description}
  {notes}
>
  <div class="video-container">
    <video
      src={`${assets}/videos/post20-tankers.mp4`}
      autoplay
      loop
      muted
      playsinline
      bind:currentTime
      bind:duration={videoDuration}
    ></video>
    {#if currentTime}
      <p id="video-time" class="font-sans text-sm">{actualTime}</p>
    {/if}
  </div>

  <p class="note">{note}</p>
  <p class="note">{source}</p>
</GraphicBlock>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;

  video {
    width: 100%;
    object-fit: cover;

    @media (max-width: 520px) {
      aspect-ratio: 1;
    }
  }

  :global(#tankers-video-block) {
    position: relative;
  }

  .video-container {
    position: relative;
  }

  #video-time {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 4px 8px;
    font-variant: tabular-nums;
  }

  .note {
    font-family: var(--theme-font-family-note);
    color: var(--theme-colour-text-secondary);
    font-size: var(--theme-font-size-xs);
    line-height: 1.3;
    font-weight: 400;
    padding: 0;
    margin: 0;
  }
</style>
